import { lazy } from "react";
import { createBrowserRouter } from "react-router-dom";
import { LoginCallback } from "@okta/okta-react";
import { AuthProvider } from "./context/AuthContext";
import Admin from "./pages/admin";
import Layout from "./components/Layout";
import { PageSpinner, PrivateRoute } from "./components";
import AdminV2 from "./pages/adminV2";

const SelectAppV1 = lazy(() => import("./pages/select-app"));
const SelectAppV2 = lazy(() => import("./pages/select-app-v2"));
const SelectApp =
  process.env.REACT_APP_SELECT_APP_V2 === "enabled" ? SelectAppV2 : SelectAppV1;

const Error = lazy(() => import("./pages/error"));
const NotFound = lazy(() => import("./pages/not-found"));
const NoPermission = lazy(() => import("./pages/no-permission"));

const usersTab =
  process.env.REACT_APP_USERS_TAB_V2 === "enabled"
    ? [
        {
          path: "/administration",
          element: <Admin />,
        },
        {
          path: "/administrationv2",
          element: <AdminV2 />,
        },
      ]
    : [
        {
          path: "/administration",
          element: <Admin />,
        },
      ];

export const router = createBrowserRouter([
  {
    element: <AuthProvider />,
    children: [
      {
        path: "/",
        element: <SelectApp />,
      },
      {
        element: (
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        ),
        children: usersTab,
      },
    ],
    errorElement: <Error />,
  },
  {
    path: "/Login",
    element: <LoginCallback loadingElement={<PageSpinner isOpen />} />,
  },
  {
    path: "/Logout",
    element: <PageSpinner isOpen />,
  },
  {
    path: "/no-permission",
    element: <NoPermission />,
  },
  {
    path: "/not-found",
    element: <NotFound />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);
